import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchVATCodes, IVatCode } from '../constants'
import { useBusinessContext } from '@root/context'
import { VatCode } from '@root/constants'

export const useVATCodes = () => {
  const { slug } = useBusinessContext()

  return useQuery({
    queryKey: [slug, 'constants', 'vatCodes'],
    queryFn: () => fetchVATCodes({ slug }),
    ...{
      enabled: !!slug,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 60 * 60 * 1000 // Adding stale time to 60 min in ms to avoid refetching
    }
  })
}

export const useVATCode = (vatCode: VatCode): IVatCode | undefined => {
  const { data: vatCodes } = useVATCodes()
  return vatCodes?.find(code => code.value === vatCode)
}
